import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { signUrl } = Urls;

const path = name => `app/pages/signList/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {
            beginTime: moment().format('YYYY-MM-DD'),
            endTime: moment().format('YYYY-MM-DD'),
        },
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelect: {
        data: {},
        handlers: {
            changeCurrentSelect(state, action) {
                return action.payload;
            },
        },
    },
    pricpleList: {
        data: [],
        handlers: {
            getList(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().signList;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
    };
    return params;
};

/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(signUrl.getCheckInfoList, 'POST', formatGetParams(getState));
            dispatch(actions.get(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncGetTaskInfo = (record, type) => {
    return async (dispatch, getState) => {
        try {
            if (type) {
                dispatch(
                    actions.changeUiStatus({
                        isLoading: true,
                    }),
                );
                // 下面的请求和结果返回需要根据接口来实现
                let result = await request(signUrl.getEveryDayCheckInfo, 'POST', {pricple: record.pricple});
                record.taskList = result;
            }
            dispatch(actions.changeCurrentSelect({record, type}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

/**
 * 获取订单列表数据
 */
export const asyncGetUserList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(signUrl.getUserList, 'GET');
            dispatch(actions.getList(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncUpdate = content => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(signUrl.update, 'POST', content);
            message.success('签到成功');
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};




// WEBPACK FOOTER //
// ./pages/sign/signList/reducers.js